import { useState } from "react";
import { Link } from "react-router-dom";

const CATEGORIES = ["All", "Meditation", "Dream Wisdom", "Vegetarianism", "Philosophy", "Mindfulness"];

const MOCK_POSTS = [
  { slug: "power-of-4p-meditation", title: "The Power of 4P Meditation", category: "Meditation", date: "Apr 18, 2026", readTime: "6 min read", excerpt: "Discover how the four-pillar meditation practice transforms consciousness and daily life.", image: "🧘" },
  { slug: "understanding-dream-symbols", title: "Understanding Dream Symbols", category: "Dream Wisdom", date: "Apr 15, 2026", readTime: "8 min read", excerpt: "A guide to interpreting the symbolic language of your subconscious mind through dream analysis.", image: "🌙" },
  { slug: "vegetarian-path-to-clarity", title: "The Vegetarian Path to Mental Clarity", category: "Vegetarianism", date: "Apr 12, 2026", readTime: "5 min read", excerpt: "How plant-based eating connects with spiritual practice and enhances meditation depth.", image: "🌿" },
  { slug: "what-is-moksha", title: "What Is Moksha? A Modern Understanding", category: "Philosophy", date: "Apr 8, 2026", readTime: "10 min read", excerpt: "Exploring the ancient concept of liberation and how it applies to contemporary spiritual seekers.", image: "✨" },
  { slug: "five-elements-meditation", title: "Five Elements Meditation Practice", category: "Meditation", date: "Apr 5, 2026", readTime: "7 min read", excerpt: "A step-by-step guide to the five elements meditation that aligns body, mind, and spirit.", image: "🌊" },
  { slug: "breathing-and-consciousness", title: "Breathing as a Gateway to Higher Consciousness", category: "Mindfulness", date: "Apr 1, 2026", readTime: "9 min read", excerpt: "How conscious breathing practices open doors to expanded states of awareness and peace.", image: "💨" },
];

export function BlogPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [search, setSearch] = useState("");

  const filtered = MOCK_POSTS.filter((p) => {
    const matchCat = activeCategory === "All" || p.category === activeCategory;
    const matchSearch = !search || p.title.toLowerCase().includes(search.toLowerCase()) || p.excerpt.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Teachings &amp; Insights</p>
          <h1 className="display-2">Blog</h1>
          <p className="hero__body" style={{ maxWidth: "540px", margin: "0 auto" }}>
            Explore articles on meditation, dream wisdom, vegetarianism, and the path to inner awakening.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Search + categories */}
          <div className="blog-controls">
            <input
              type="search"
              placeholder="Search articles…"
              className="form-input blog-search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ maxWidth: "360px" }}
            />
            <div className="blog-cats">
              {CATEGORIES.map((c) => (
                <button
                  key={c}
                  className={`events-tag-chip ${activeCategory === c ? "active" : ""}`}
                  onClick={() => setActiveCategory(c)}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>

          {/* Posts grid */}
          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "3rem 0", color: "var(--c-ink-75)" }}>
              No articles found for "{search}". Try a different search.
            </div>
          ) : (
            <div className="blog-grid">
              {filtered.map((post) => (
                <article key={post.slug} className="blog-card">
                  <div className="blog-card__image">{post.image}</div>
                  <div className="blog-card__body">
                    <div className="blog-card__meta">
                      <span className="blog-card__cat">{post.category}</span>
                      <span className="blog-card__dot">·</span>
                      <span>{post.date}</span>
                      <span className="blog-card__dot">·</span>
                      <span>{post.readTime}</span>
                    </div>
                    <h3 className="blog-card__title">{post.title}</h3>
                    <p className="blog-card__excerpt">{post.excerpt}</p>
                    <Link to={`/blog/${post.slug}`} className="blog-card__link">Read more →</Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export function BlogPostPage() {
  return (
    <section className="section">
      <div className="container container--reading">
        <Link to="/blog" style={{ color: "var(--c-brand)", fontSize: "0.9rem" }}>← Back to Blog</Link>
        <div className="card" style={{ marginTop: "1.5rem", textAlign: "center", padding: "4rem 2rem" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📖</div>
          <h2>Article content coming soon</h2>
          <p style={{ color: "var(--c-ink-75)" }}>Full article pages will be powered by WordPress CMS.</p>
          <Link to="/blog" className="btn btn--outline" style={{ marginTop: "1rem" }}>Browse All Articles</Link>
        </div>
      </div>
    </section>
  );
}
